var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAaveCarousel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.792969,
    y: 0.477539,
    width: 136.782,
    height: 136.782,
    rx: 27.3563,
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.807 98.6007L76.2641 36.8692C74.8206 33.6793 72.6868 32.1157 69.8626 32.1157H67.6034C64.7792 32.1157 62.6454 33.6793 61.2019 36.8692L50.0943 63.764H41.6837C40.4728 63.7687 39.3125 64.2508 38.4548 65.1056C37.5971 65.9604 37.1111 67.119 37.1023 68.3299V68.3923C37.1111 69.6033 37.5971 70.7618 38.4548 71.6166C39.3125 72.4714 40.4728 72.9535 41.6837 72.9582H46.2015L35.596 98.6007C35.3954 99.1633 35.2894 99.7552 35.2822 100.352C35.2822 101.791 35.7215 102.917 36.5375 103.793C37.3534 104.668 38.4829 105.105 39.9265 105.105C40.8743 105.093 41.7949 104.787 42.5617 104.229C43.3777 103.667 43.9425 102.854 44.3818 101.915L56.0551 72.9572H64.1511C65.362 72.9525 66.5222 72.4705 67.38 71.6157C68.2377 70.7609 68.7237 69.6023 68.7325 68.3914V68.2662C68.7237 67.0553 68.2377 65.8967 67.38 65.0419C66.5222 64.1871 65.362 63.7051 64.1511 63.7004H59.8211L68.7329 41.4973L93.0209 101.916C93.4602 102.854 94.0251 103.667 94.841 104.23C95.608 104.787 96.5289 105.093 97.477 105.106C98.9204 105.106 100.05 104.668 100.866 103.792C101.682 102.916 102.121 101.791 102.121 100.352C102.145 99.7524 102.038 99.1548 101.807 98.6007Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 124.854,
    y1: 31.527,
    x2: 23.0884,
    y2: 117.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6509E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EBAC6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.3036,
    height: 75,
    fill: "white",
    transform: "translate(35.0322 31.3682)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaveCarousel);
export default __webpack_public_path__ + "static/media/aave-carousel.a4544e06d8fb83117715cb48e9697790.svg";
export { ForwardRef as ReactComponent };